module.exports = __webpack_public_path__ + "static/media/crown.54b40f91.svg";